import sideScanCode from './sideScanCode.vue'
export default sideScanCode
